import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, createSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { Paper, Grid, Dialog, DialogTitle, Typography, Button, DialogContent } from "@mui/material";

import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"


import { selectReportCriteriaEntities } from "../../../reducers/admincenter_reportcriteria";
import ResponsiveRectangle from "../skeletons/ResponsiveRectangle";
import { selectUIReportEntities } from "../../../reducers/admincenter_uireport";
import DynamicComponentItem from "../ArcDynamicComponentItem";


import { selectGlobalSettingEntities } from "../../../reducers/reference_settings";
import ReportAggregateFilterControl from "./ReportAggregateFilterControl";


const ReportAggregateReport = () => {

    const dispatch = useDispatch()

    const DataReport = useSelector(state => state.datareports.entities)
    const settings = useSelector(state => selectGlobalSettingEntities(state))
    const MinAggRecords = (settings?.organization && settings?.organization['AGGREGATE REPORT MINIMUM PARTICIPANTS']) ? settings.organization['AGGREGATE REPORT MINIMUM PARTICIPANTS'] : 50
    const DataReportStatus = useSelector(state => state.datareports.status)
    const UIReportStatus = useSelector(state => state.uireports.status)
    const ReportCriteria = useSelector(state => selectReportCriteriaEntities(state))
    const [reportFilters, setReportFilters] = useState([])

    const ReportJSON = useSelector(state => selectUIReportEntities(state))

    const FilterDataFunction = (x) => {
        return true
    }
    const FilteredData = DataReport.filter((x, i) => FilterDataFunction(x))
    //const PreventLeak = (FilteredData.length > MinAggRecords) ? FilteredData : []
    const PreventLeak =  FilteredData 
    const cannotReadOnlyNonSense = [...ReportJSON]
    const FilteredSections = cannotReadOnlyNonSense.filter(x => { return x.Visible === '1' || x.Visible === 1 })
    const OrderedSections = FilteredSections.sort(function (a, b) { return parseInt(a.Order) - parseInt(b.Order) })



    /*if (!currentUser) {
      return <Navigate to="/login" />;
    }*/

    useEffect(() => { }, [dispatch, UIReportStatus, DataReportStatus])




    if (PreventLeak.length > 0) {
        return (
            <Grid container direction="row" alignItems="top" justifyContent="center" spacing={3} >
                
                {(UIReportStatus === 'success' && DataReportStatus === 'success') ? (

                    OrderedSections.map((x, i) => {

                        return (
                            <Grid item
                                xs={12}
                                sm={12}
                                md={x.ComponentProperties.Size}
                                lg={x.ComponentProperties.Size}
                                xl={x.ComponentProperties.Size}
                                key={"staticARC_" + i} id={"staticARC_" + i}>
                                <DynamicComponentItem ReportComponentJSON={x} DataReportData={PreventLeak} index={i} />
                            </Grid>
                        )
                    })

                ) : (UIReportStatus === 'loading' || DataReportStatus === 'loading') ? (
                    <Grid item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        key={"staticARC_Loader"} id={"staticARC_Loader"}>

                        <ResponsiveRectangle height="40" />
                    </Grid>
                ) : (
                    <></>
                )
                }
            </Grid>
        )
    }

    return (

        <Grid container direction="row" alignItems="top" justifyContent="center" spacing={3} >
            <Typography variant="h6" align="center" color="error">Filter does not meet minimum participant aggregation standards.</Typography>
        </Grid>

    )



};

export default ReportAggregateReport;

/*  <Paper elevation={16} style={{marginTop: '100px', padding:'40px'}}>
          <h3>
              HOME
            </h3>
            <Button onClick={logoutUser}>Logout</Button>
            <TermsAndConditions props={TCS.TsAndCsPage}/>
          </Paper> */